// src/hooks/Refund/useCreditDashBoard_Csv.js
import { useState } from 'react';
import axios from 'axios';
import { Api_Url } from "../../utils/ApiUrl";
import { formatDecimal } from '../../utils/formatDecimal';
// import { formatDate } from '../../utils/formatDate';

export const useCreditDashBoard_Csv = () => {
    const [isExporting, setIsExporting] = useState(false);
    const [exportError, setExportError] = useState(null);

    const downloadCSV = (data, fileName) => {
        try {
            if (!data || data.length === 0) {
                throw new Error('No data available to export');
            }

            // Convert data to CSV format
            const csvRows = [];

            // Get headers and format them for better readability
            const headers = Object.keys(data[0]);
            const formattedHeaders = headers.map(header => {
                // Format camelCase or snake_case headers to Title Case with spaces
                return header
                    .replace(/([A-Z])/g, ' $1') // Insert a space before all caps
                    .replace(/_/g, ' ') // Replace underscores with spaces
                    .replace(/^\w/, c => c.toUpperCase()); // Capitalize first letter
            });

            csvRows.push(formattedHeaders.join(','));

            // Add data rows
            for (const row of data) {
                const values = headers.map(header => {
                    const value = row[header];
                    if (value === null || value === undefined) {
                        return '""';
                    }
                    // Handle values that contain commas or quotes
                    const escaped = String(value).replace(/"/g, '""');
                    return `"${escaped}"`;
                });
                csvRows.push(values.join(','));
            }

            // Add BOM for Excel to recognize UTF-8
            const BOM = '\uFEFF';
            const csvString = BOM + csvRows.join('\n');

            // Create and download CSV file
            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up
            setTimeout(() => {
                URL.revokeObjectURL(url);
            }, 100);
        } catch (error) {
            console.error('Error generating CSV:', error);
            throw new Error('Failed to generate CSV file: ' + error.message);
        }
    };

    const exportToCSV = async (tabType, startDate = null, endDate = null) => {
        setIsExporting(true);
        setExportError(null);

        try {
            const token = localStorage.getItem('accessToken');
            if (!token) {
                throw new Error('Authentication token not found. Please log in again.');
            }

            let endpoint = '';
            let fileName = '';
            const dateStr = new Date().toISOString().split('T')[0];

            // Determine endpoint based on tab type
            if (tabType === 'issued') {
                endpoint = `${Api_Url}/credit/bulk/issued/transactions?orderField=createdAt&orderDirection=-1`;
                fileName = `credit_issued_transactions_${dateStr}.csv`;
            } else {
                endpoint = `${Api_Url}/credit/bulk/consumed/transactions?orderField=createdAt&orderDirection=-1`;
                fileName = `credit_consumed_transactions_${dateStr}.csv`;
            }

            // Add date filters if provided
            if (startDate && endDate) {
                const formattedStartDate = startDate.toISOString();
                const formattedEndDate = endDate.toISOString();
                endpoint += `&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;

                // Add date range to filename
                const startDateStr = startDate.toISOString().split('T')[0];
                const endDateStr = endDate.toISOString().split('T')[0];
                fileName = `${tabType}_transactions_${startDateStr}_to_${endDateStr}.csv`;
            }

            console.log(`Fetching data from: ${endpoint}`);

            const response = await axios.get(endpoint, {
                headers: { Authorization: `Bearer ${token}` }
            });
console.log(response.data, 'rressdflsdfldf');

            if (!response.data) {
                throw new Error('Invalid data format received from the server');
            }

            const transactions = response.data;

            if (transactions.length === 0) {
                throw new Error('No data available to export');
            }

            // // Format date for better readability
            const formatDate = (dateString) => {
                const date = new Date(dateString);
                return date.toLocaleString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                });
            };

            // Prepare data for CSV based on tab type
            let csvData = [];
            if (tabType === 'issued') {
                csvData = transactions.map(transaction => ({
                    Date: formatDate(transaction.createdAt),
                    Country: transaction.country || 'N/A',
                    TransactionHash: transaction.transactionHash || 'N/A',
                    WalletAddress: transaction.by || 'N/A',
                    PrivateSale: transaction.privateSale || 'N/A',
                    CreditRefunded: transaction.creditRefunded.toFixed(4),
                    
                }));
            } else {
                csvData = transactions.map(transaction => ({
                    Date: formatDate(transaction.createdAt),
                    Country: transaction.country || 'N/A',
                    WalletAddress: transaction.by || 'N/A',
                    PrivateSale: transaction.privateSale || 'N/A',
                    CreditConsumed: formatDecimal(transaction.creditConsumed),
                    TokenPurchased: formatDecimal(transaction.tokenPurchased),
                }));
            }

            // Download the CSV file
            downloadCSV(csvData, fileName);

            return true;
        } catch (error) {
            console.error('Error exporting CSV:', error);
            setExportError(error.message || 'Failed to export data');
            throw error;
        } finally {
            setIsExporting(false);
        }
    };

    return {
        exportToCSV,
        isExporting,
        exportError
    };
};